<div class="editor-in-view" [ngClass]="{'editor-side-by-side' : editorPreview}">
 
  <div *ngIf="item && item.view === 'edit' && !checkDisable()" [ngClass]="{'editor-inline-display' : editorPreview}">
    <!-- <h3 *ngIf="item.title && item.title.length > 0">{{item.title}}</h3> -->
    <div class="scaffold-bool">
      <scaffold-toggle-slide status="info" [(ngModel)]="editorPreview">{{'preview'| translation}}<span nbSuffix pTooltip="Use this editor to add advanced layout and content components">
        <i class="fas fa-question-circle"></i> </span></scaffold-toggle-slide>

    </div>
    <app-editor *ngIf="item.view === 'edit'" [items]="editorcontent" [templates]="item.templates" [undoService]="undoService" [data]="data" [parentView]="item" [info]="editorDetails" [parents]="[{type:'view'}]" (editorChange)="editDirty($event)"></app-editor>
    <p style="text-align:center;" class="scaffold-guidance-text" *ngIf="(!editorcontent || editorcontent.length < 1)">{{item.text}}</p>
  </div>
  <div class="editor-inline-display" *ngIf="editorPreview || item.view != 'edit' || checkDisable()">
    <app-view [childview]="item.childview || childview" [items]="editorcontent" [data]="data" [info]="editorDetails"></app-view>
  </div>
</div>
